import { render } from "./EventList.vue?vue&type=template&id=ae4f5ed8&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=ae4f5ed8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae4f5ed8"

export default script